<div class="title">{{'Plant Performance Snapshot' | translate}}</div>

<ng-container>
    <div *ngFor="let p of plants" class="plant-card" (click)="onPick(p)">
        <mat-card class="ep-card">
            <!-- three-dots menu -->
            <button mat-icon-button class="menu-btn" [matMenuTriggerFor]="menu" aria-label="More actions">
                <mat-icon>more_vert</mat-icon>
            </button>

            <mat-menu #menu="matMenu">
                <button (click)="onView(p)" mat-menu-item>
                    <mat-icon>visibility</mat-icon>
                    <span>{{'View' | translate}}</span>
                </button>
            </mat-menu>

            <div class="thumb">
                <img src="images/defultPlantImage.jpg" alt="thumbnail" />
            </div>

            <div class="content">
                <div class="metrics">
                    <div class="plants-box userId">
                        <mat-icon class="i">
                            handshake
                        </mat-icon>
                        {{'Customer_type' | translate}}
                        <span>{{p.customerType}}</span>
                    </div>

                    <div class="plants-box ownerName">
                        <mat-icon class="i">
                            account_circle
                        </mat-icon>
                        {{'owner_name' | translate}}
                        <span>{{p.plantOwner}}</span>
                    </div>

                    <div class="plants-box createdAt">
                        <mat-icon class="i">
                            timer
                        </mat-icon>
                        {{'Created_At' | translate}}
                        <span>
                            {{p.createdAt | timestampDate:'en-GB':undefined:{ dateStyle:'medium', timeStyle:'short' } }}
                        </span>
                    </div>

                    <div class="plants-box createdAt">
                        <mat-icon class="i">
                            update
                        </mat-icon>
                        {{'Last_update' | translate}}
                        <span>
                            {{p.lastUpdate | timestampDate:'en-GB':undefined:{ dateStyle:'medium', timeStyle:'short' }
                            }}
                        </span>
                    </div>

                    <div class="plants-box createdAt">
                        <mat-icon class="i circle" [class.active]="!p.disabled" [class.inactive]="p.disabled">
                            radio_button_checked
                        </mat-icon>
                        {{'Status' | translate}}
                        <span class="status">
                            {{ p.disabled ? 'Inactive' : 'Active' }}
                        </span>
                    </div>
                </div>
            </div>
        </mat-card>
    </div>
</ng-container>